module.exports = __webpack_public_path__ + "static/media/address_icon.363c3265.svg";